import sharedResources, { mergeI18nResources } from "@ms/shared/i18n/resources";
import authPageResources from "./auth_page_resources";

const commonResources = {
    th: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "การศึกษายืดหยุ่นตอบโจทย์ชีวิต",
                contactUs: "ติดต่อเรา",
                contactEmail: "อีเมล {{email}}",
                contactDetails: "หากมีข้อสงสัย ติดต่อเราได้ที่\n02-079-5475 หรือ LINE @EEFThailand",
                home: "หน้าหลัก",
                language: "ภาษา",
                changeLanguage: "เปลี่ยนภาษา",
                languages: {
                    th: "ไทย",
                    en: "อังกฤษ",
                    my: "พม่า",
                    lo: "ลาว",
                    id: "อินโดนีเซีย",
                    ms: "มาเลย์",
                },
            },
            search: {
                placeholder: "ค้นหา...",
                usageCount: "{{count}} ครั้ง",
                user: "ผู้ใช้งาน",
                group: "กลุ่ม",
            },
            footer: {
                title: "Mobile School การศึกษายืดหยุ่นตอบโจทย์ชีวิต",
                organization: "กองทุนเพื่อความเสมอภาคทางการศึกษา",
            },
        },
    },
    en: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "Flexible learning for real life",
                contactUs: "Contact us",
                contactEmail: "Email {{email}}",
                contactDetails: "If you have any questions, contact us at\n02-079-5475 or LINE @EEFThailand",
                home: "Home",
                language: "Language",
                changeLanguage: "Change language",
                languages: {
                    th: "Thai",
                    en: "English",
                    my: "Burmese",
                    lo: "Lao",
                    id: "Indonesian",
                    ms: "Malay",
                },
            },
            search: {
                placeholder: "Search...",
                usageCount: "{{count}} times",
                user: "User",
                group: "Group",
            },
            footer: {
                title: "Mobile School Flexible learning for real life",
                organization: "Equitable Education Fund",
            },
        },
    },
    id: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "Pembelajaran fleksibel untuk kehidupan nyata",
                contactUs: "Hubungi kami",
                contactEmail: "Email {{email}}",
                contactDetails: "Jika ada pertanyaan, hubungi kami di\n02-079-5475 atau LINE @EEFThailand",
                home: "Beranda",
                language: "Bahasa",
                changeLanguage: "Ubah bahasa",
                languages: {
                    th: "Thai",
                    en: "Inggris",
                    my: "Burma",
                    lo: "Lao",
                    id: "Indonesia",
                    ms: "Melayu",
                },
            },
            search: {
                placeholder: "Cari...",
                usageCount: "{{count}} kali",
                user: "Pengguna",
                group: "Grup",
            },
            footer: {
                title: "Mobile School Pembelajaran fleksibel untuk kehidupan nyata",
                organization: "Dana Pendidikan yang Setara",
            },
        },
    },
    ms: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "Pembelajaran fleksibel untuk kehidupan sebenar",
                contactUs: "Hubungi kami",
                contactEmail: "E-mel {{email}}",
                contactDetails: "Jika ada pertanyaan, hubungi kami di\n02-079-5475 atau LINE @EEFThailand",
                home: "Laman utama",
                language: "Bahasa",
                changeLanguage: "Tukar bahasa",
                languages: {
                    th: "Thai",
                    en: "Inggeris",
                    my: "Burma",
                    lo: "Lao",
                    id: "Indonesia",
                    ms: "Melayu",
                },
            },
            search: {
                placeholder: "Cari...",
                usageCount: "{{count}} kali",
                user: "Pengguna",
                group: "Kumpulan",
            },
            footer: {
                title: "Mobile School Pembelajaran fleksibel untuk kehidupan sebenar",
                organization: "Dana Pendidikan Saksama",
            },
        },
    },
    my: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "ဘဝနှင့်ကိုက်ညီသော ပျော့ပြောင်းသင်ယူမှု",
                contactUs: "ဆက်သွယ်ရန်",
                contactEmail: "အီးမေးလ် {{email}}",
                contactDetails: "မေးမြန်းလိုသည်များရှိပါက ဆက်သွယ်ရန်\n02-079-5475 သို့မဟုတ် LINE @EEFThailand",
                home: "ပင်မစာမျက်နှာ",
                language: "ဘာသာစကား",
                changeLanguage: "ဘာသာစကားပြောင်းရန်",
                languages: {
                    th: "ထိုင်း",
                    en: "အင်္ဂလိပ်",
                    my: "မြန်မာ",
                    lo: "လာအို",
                    id: "အင်ဒိုနီးရှား",
                    ms: "မလေး",
                },
            },
            search: {
                placeholder: "ရှာရန်...",
                usageCount: "{{count}} ကြိမ်",
                user: "အသုံးပြုသူ",
                group: "အဖွဲ့",
            },
            footer: {
                title: "Mobile School ဘဝနှင့်ကိုက်ညီသော ပျော့ပြောင်းသင်ယူမှု",
                organization: "ပညာရေးဆိုင်ရာ တန်းတူညီမျှရေး ရန်ပုံငွေ",
            },
        },
    },
    lo: {
        translation: {
            header: {
                brand: "Mobile School",
                tagline: "ການຮຽນຮູ້ທີ່ຍືດຫຍຸ່ນ ຕອບໂຈດຊີວິດ",
                contactUs: "ຕິດຕໍ່ເຮົາ",
                contactEmail: "ອີເມວ {{email}}",
                contactDetails: "ຫາກມີຂໍ້ສົງໄສ ຕິດຕໍ່ເຮົາໄດ້ທີ່\n02-079-5475 ຫຼື LINE @EEFThailand",
                home: "ໜ້າຫຼັກ",
                language: "ພາສາ",
                changeLanguage: "ປ່ຽນພາສາ",
                languages: {
                    th: "ໄທ",
                    en: "ອັງກິດ",
                    my: "ມຽນມາ",
                    lo: "ລາວ",
                    id: "ອິນໂດເນເຊຍ",
                    ms: "ມາເລ",
                },
            },
            search: {
                placeholder: "ຄົ້ນຫາ...",
                usageCount: "{{count}} ຄັ້ງ",
                user: "ຜູ້ໃຊ້",
                group: "ກຸ່ມ",
            },
            footer: {
                title: "Mobile School ການຮຽນຮູ້ທີ່ຍືດຫຍຸ່ນ ຕອບໂຈດຊີວິດ",
                organization: "ກອງທຶນເພື່ອຄວາມສະເໝີພາບທາງການສຶກສາ",
            },
        },
    },
};

const ssoResources = {
    th: {
        translation: {
            common: {
                actions: {
                    logout: "ออกจากระบบ",
                    viewAll: "ดูทั้งหมด",
                    save: "บันทึก",
                    cancel: "ยกเลิก",
                    edit: "แก้ไข",
                    delete: "ลบ",
                    search: "ค้นหา",
                    choosePhoto: "เลือกรูป",
                    upload: "อัปโหลด",
                },
                roles: {
                    guest: "ผู้ใช้ทั่วไป",
                    admin: "แอดมินศูนย์",
                    teacher: "ผู้สอน",
                    caseManager: "ครูที่ปรึกษา",
                    curriculum: "ผู้เชี่ยวชาญด้านหลักสูตร รายวิชา และการวัดประเมินผล",
                    psychologist: "ผู้เชี่ยวชาญด้านพัฒนาการและจิตวิทยา",
                    student: "ผู้เรียน",
                    adminSystem: "แอดมินระบบ",
                },
                notFound: "เซิร์ฟเวอร์ไม่พบเว็บไซต์ที่ร้องขอ โปรดตรวจสอบ URL ที่ท่านพิมพ์เข้าสู่ระบบ",
                loading: {
                    default: "กำลังโหลด...",
                },
                status: {
                    active: "Active",
                    inactive: "Inactive",
                },
                toast: {
                    success: "Success",
                    error: "Error",
                    successDetail: "{{detail}} สำเร็จ",
                    failDetail: "{{detail}} ล้มเหลว",
                },
            },
            menu: {
                title: "เมนู",
            },
            notification: {
                title: "การแจ้งเตือน ({{count}})",
                markAllRead: "ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว",
                unknownGroup: "กลุ่มไม่ทราบชื่อ",
                unknownUser: "ไม่ทราบชื่อ",
                sections: {
                    new: "ใหม่",
                    friendRequests: "คำขอเป็นเพื่อน",
                    groupRequests: "คำขอของกลุ่ม",
                    educationalMedia: "สื่อการสอน",
                },
                messages: {
                    commentOnPost: "มีคนแสดงความคิดเห็นในโพสต์ของคุณ",
                    likeOnPost: "มีคนถูกใจโพสต์ของคุณ",
                    replyOnComment: "มีคนตอบกลับความคิดเห็นของคุณ",
                    friendRequest: "คุณได้รับคำขอเป็นเพื่อน",
                    acceptedFriendRequest: "คุณได้ตอบรับคำขอเป็นเพื่อนแล้ว",
                    groupMemberPosted: "มีสมาชิกในกลุ่มโพสต์ใหม่",
                    groupMemberRequest: "คุณได้รับคำขอเข้าร่วมกลุ่ม",
                    acceptedGroupMemberRequest: "คำขอเข้าร่วมกลุ่มของคุณได้รับการอนุมัติ",
                    rejectedGroupMemberRequest: "คำขอเข้าร่วมกลุ่มของคุณถูกปฏิเสธ",
                    newEducationalMedia: "มีสื่อการสอนใหม่ที่คุณอาจสนใจ",
                    default: "คุณมีการแจ้งเตือนใหม่",
                },
            },
            auth: {
                login: {
                    welcome: "ยินดีต้อนรับ",
                    username: "ชื่อผู้ใช้:",
                    password: "รหัสผ่าน:",
                    rememberUser: "จดจำผู้ใช้งาน",
                    forgotPassword: "ลืมรหัสผ่าน",
                    submit: "เข้าสู่ระบบ",
                    guestHint: "เข้าสู่ระบบผู้ใช้งาน หรือแบบผู้เยี่ยมชม",
                    googleLogin: "Login with Google",
                    registerHint: "สนใจสมัครลงทะเบียนสำหรับผู้เรียนใหม่",
                    register: "ลงทะเบียน",
                    errors: {
                        credentialsRequired: "กรุณาระบุชื่อผู้ใช้งานและรหัสผ่าน",
                        success: "เข้าสู่ระบบสำเร็จ",
                        tooManyAttempts: "ผู้ใช้งานนี้มีความพยายามเข้าระบบหลายครั้ง กรุณาทดลองเข้าระบบใหม่หลังจาก 5 นาที",
                        invalidCredentials: "ชื่อหรือรหัสผ่านไม่ถูกต้อง",
                    },
                },
                register: {
                    pageTitle: "ลงทะเบียนบัญชีผู้ใช้งานใหม่",
                    emailSectionTitle: "ข้อมูลอีเมล",
                    emailSectionDesc: "กรุณากรอกอีเมลเพื่อรับรหัสผู้ใช้งานและรหัสผ่านสำหรับการลงทะเบียน",
                    email: "อีเมล",
                    personalSectionTitle: "ข้อมูลส่วนตัว",
                    personalSectionDesc: "กรอกข้อมูลส่วนบุคคลเพื่อแสดงผลในระบบและใช้ในการสมัครเข้าหน่วยการศึกษา",
                    citizenId: "เลขบัตรประชาชน",
                    titleLabel: "คำนำหน้า",
                    fullName: "ชื่อ-นามสกุล",
                    titleEn: "คำนำหน้า (ภาษาอังกฤษ)",
                    fullNameEn: "ชื่อ-นามสกุล (ภาษาอังกฤษ)",
                    birthDate: "วัน/เดือน/ปีเกิด",
                    birthDatePlaceholder: "dd/mm/yyyy",
                    phone: "เบอร์โทรที่ติดต่อได้",
                    religion: "ศาสนา",
                    submit: "ลงทะเบียน",
                    cancel: "ยกเลิก",
                    successOtp: "ทำการส่งรหัส OTP ไปที่ email ของท่านแล้ว",
                    titles: {
                        boy: "เด็กชาย",
                        girl: "เด็กหญิง",
                        mr: "นาย",
                        miss: "นางสาว",
                        mrs: "นาง",
                    },
                    titlesEn: {
                        mr: "Mr.",
                        miss: "Miss",
                        ms: "Ms.",
                        mrs: "Mrs.",
                    },
                    religions: {
                        buddhist: "พุทธ",
                        christian: "คริส",
                    },
                },
                resetPassword: {
                    title: "ลืมรหัสผ่าน",
                    instruction: "ระบุที่อยู่อีเมลที่คุณใช้ และเราจะส่งคำแนะนำในการรีเซ็ตรหัสผ่านของคุณ",
                    email: "อีเมล์",
                    submit: "ส่งอีเมล์",
                    successMessage: "เราได้ส่งอีเมล์ลิงก์สำหรับรีเซ็ตรหัสผ่านถึงคุณแล้ว ควรปรากฏในกล่องจดหมายของคุณภายในห้านาทีถัดไป หากคุณยังไม่เห็น โปรดตรวจสอบที่ไฟลเดอร์สแปมของคุณ !!",
                    emailRequired: "กรุณาระบุอีเมล์",
                },
                redeemReset: {
                    title: "รีเซ็ตรหัสผ่าน",
                    username: "ชื่อผู้ใช้งาน",
                    password: "รหัสผ่าน",
                    confirmPassword: "ยืนยันรหัสผ่าน",
                    passwordHint: "รหัสผ่านต้องมีความยาว 8 ตัวอักษร",
                    submit: "เปลี่ยนรหัสผ่าน",
                    linkExpired: "ลิงก์หมดอายุ หรือถูกใช้ในการเปลี่ยนรหัสผ่านไปแล้ว",
                    errors: {
                        passwordMinLength: "รหัสผ่านต้องมีความยาว 8 ตัวอักษร",
                        passwordMismatch: "รหัสผ่านที่ระบุมาไม่เหมือนกัน",
                        success: "เปลี่ยนแปลงรหัสผ่านสำเร็จ",
                        failed: "พบปัญหาไม่สามารถเปลี่ยนรหัสผ่านได้ กรุณาทดลองเปลี่ยนรหัสผ่านใหม่",
                    },
                },
                verify: {
                    title: "ยืนยันรหัส",
                    placeholder: "กรอกรหัสยืนยัน",
                    submit: "ส่ง",
                    success: "ยืนยันสำเร็จ ส่งบัญชีไปที่ email ของท่านแล้ว",
                },
            },
            profile: {
                title: "โปรไฟล์",
                firstName: "ชื่อ :",
                lastName: "นามสกุล :",
                email: "อีเมล :",
                school: "โรงเรียน :",
                schoolArea: "สำนักงานเขต :",
                province: "จังหวัด",
                district: "เขต/อำเภอ",
                position: "ตำแหน่ง :",
                phone: "เบอร์โทรศัพท์ :",
                placeholders: {
                    school: "รหัส-ชื่อโรงเรียน",
                    schoolArea: "สำนักงานเขต",
                    province: "จังหวัด",
                    district: "เขต/อำเภอ",
                    phone: "999-999-9999",
                },
                toast: {
                    formSubmitted: "บันทึกข้อมูลแล้ว",
                    uploadSuccess: "อัปโหลดรูปสำเร็จ",
                    updateFailed: "อัปเดตข้อมูลล้มเหลว",
                },
            },
        },
    },
    en: {
        translation: {
            common: {
                actions: {
                    logout: "Log out",
                    viewAll: "View all",
                    save: "Save",
                    cancel: "Cancel",
                    edit: "Edit",
                    delete: "Delete",
                    search: "Search",
                    choosePhoto: "Choose photo",
                    upload: "Upload",
                },
                roles: {
                    guest: "User",
                    admin: "Center admin",
                    teacher: "Teacher",
                    caseManager: "Advisor teacher",
                    curriculum: "Curriculum, subject, and assessment specialist",
                    psychologist: "Development and psychology specialist",
                    student: "Learner",
                    adminSystem: "System admin",
                },
                notFound: "The server could not find the requested page. Please check the URL you entered.",
                loading: {
                    default: "Loading...",
                },
                status: {
                    active: "Active",
                    inactive: "Inactive",
                },
                toast: {
                    success: "Success",
                    error: "Error",
                    successDetail: "{{detail}} successful",
                    failDetail: "{{detail}} failed",
                },
            },
            menu: {
                title: "Menu",
            },
            notification: {
                title: "Notifications ({{count}})",
                markAllRead: "Mark all as read",
                unknownGroup: "Unknown group",
                unknownUser: "Unknown user",
                sections: {
                    new: "New",
                    friendRequests: "Friend requests",
                    groupRequests: "Group requests",
                    educationalMedia: "Teaching media",
                },
                messages: {
                    commentOnPost: "Someone commented on your post",
                    likeOnPost: "Someone liked your post",
                    replyOnComment: "Someone replied to your comment",
                    friendRequest: "You received a friend request",
                    acceptedFriendRequest: "You accepted a friend request",
                    groupMemberPosted: "A group member posted something new",
                    groupMemberRequest: "You received a group join request",
                    acceptedGroupMemberRequest: "Your group join request was approved",
                    rejectedGroupMemberRequest: "Your group join request was rejected",
                    newEducationalMedia: "New teaching media you may be interested in",
                    default: "You have a new notification",
                },
            },
            auth: {
                login: {
                    welcome: "Welcome",
                    username: "Username:",
                    password: "Password:",
                    rememberUser: "Remember me",
                    forgotPassword: "Forgot password",
                    submit: "Log in",
                    guestHint: "Log in as a user or guest",
                    googleLogin: "Login with Google",
                    registerHint: "Interested in registering as a new learner?",
                    register: "Register",
                    errors: {
                        credentialsRequired: "Please enter your username and password",
                        success: "Logged in successfully",
                        tooManyAttempts: "Too many login attempts. Please try again after 5 minutes",
                        invalidCredentials: "Invalid username or password",
                    },
                },
                register: {
                    pageTitle: "Register a new account",
                    emailSectionTitle: "Email information",
                    emailSectionDesc: "Enter your email to receive your username and password for registration",
                    email: "Email",
                    personalSectionTitle: "Personal information",
                    personalSectionDesc: "Enter personal details for display in the system and education unit applications",
                    citizenId: "National ID number",
                    titleLabel: "Title",
                    fullName: "Full name",
                    titleEn: "Title (English)",
                    fullNameEn: "Full name (English)",
                    birthDate: "Date of birth",
                    birthDatePlaceholder: "dd/mm/yyyy",
                    phone: "Contact phone number",
                    religion: "Religion",
                    submit: "Register",
                    cancel: "Cancel",
                    successOtp: "An OTP code has been sent to your email",
                    titles: {
                        boy: "Boy",
                        girl: "Girl",
                        mr: "Mr.",
                        miss: "Miss",
                        mrs: "Mrs.",
                    },
                    titlesEn: {
                        mr: "Mr.",
                        miss: "Miss",
                        ms: "Ms.",
                        mrs: "Mrs.",
                    },
                    religions: {
                        buddhist: "Buddhist",
                        christian: "Christian",
                    },
                },
                resetPassword: {
                    title: "Forgot password",
                    instruction: "Enter the email address you use and we will send password reset instructions",
                    email: "Email",
                    submit: "Send email",
                    successMessage: "We have sent a password reset link to your email. It should arrive within the next few minutes. If you do not see it, please check your spam folder.",
                    emailRequired: "Please enter your email",
                },
                redeemReset: {
                    title: "Reset password",
                    username: "Username",
                    password: "Password",
                    confirmPassword: "Confirm password",
                    passwordHint: "Password must be at least 8 characters",
                    submit: "Change password",
                    linkExpired: "This link has expired or has already been used to change the password",
                    errors: {
                        passwordMinLength: "Password must be at least 8 characters",
                        passwordMismatch: "Passwords do not match",
                        success: "Password changed successfully",
                        failed: "Could not change password. Please try again",
                    },
                },
                verify: {
                    title: "Verify code",
                    placeholder: "Enter verification code",
                    submit: "Submit",
                    success: "Verified successfully. Account details have been sent to your email",
                },
            },
            profile: {
                title: "Profile",
                firstName: "First name:",
                lastName: "Last name:",
                email: "Email:",
                school: "School:",
                schoolArea: "District office:",
                province: "Province",
                district: "District",
                position: "Position:",
                phone: "Phone:",
                placeholders: {
                    school: "School code - name",
                    schoolArea: "District office",
                    province: "Province",
                    district: "District",
                    phone: "999-999-9999",
                },
                toast: {
                    formSubmitted: "Profile saved",
                    uploadSuccess: "Photo uploaded successfully",
                    updateFailed: "Failed to update profile",
                },
            },
        },
    },
    id: {
        translation: {
            common: {
                actions: {
                    logout: "Keluar",
                    viewAll: "Lihat semua",
                    save: "Simpan",
                    cancel: "Batal",
                    edit: "Edit",
                    delete: "Hapus",
                    search: "Cari",
                    choosePhoto: "Pilih foto",
                    upload: "Unggah",
                },
                roles: {
                    guest: "Pengguna",
                    admin: "Admin pusat",
                    teacher: "Guru",
                    caseManager: "Guru pembimbing",
                    curriculum: "Spesialis kurikulum, mata pelajaran, dan penilaian",
                    psychologist: "Spesialis pengembangan dan psikologi",
                    student: "Peserta belajar",
                    adminSystem: "Admin sistem",
                },
                notFound: "Server tidak dapat menemukan halaman yang diminta. Silakan periksa URL yang Anda masukkan.",
                loading: {
                    default: "Memuat...",
                },
                status: {
                    active: "Aktif",
                    inactive: "Tidak aktif",
                },
                toast: {
                    success: "Berhasil",
                    error: "Kesalahan",
                    successDetail: "{{detail}} berhasil",
                    failDetail: "{{detail}} gagal",
                },
            },
            menu: {
                title: "Menu",
            },
            notification: {
                title: "Notifikasi ({{count}})",
                markAllRead: "Tandai semua sebagai sudah dibaca",
                unknownGroup: "Grup tidak dikenal",
                unknownUser: "Pengguna tidak dikenal",
                sections: {
                    new: "Baru",
                    friendRequests: "Permintaan pertemanan",
                    groupRequests: "Permintaan grup",
                    educationalMedia: "Media pengajaran",
                },
                messages: {
                    commentOnPost: "Seseorang mengomentari postingan Anda",
                    likeOnPost: "Seseorang menyukai postingan Anda",
                    replyOnComment: "Seseorang membalas komentar Anda",
                    friendRequest: "Anda menerima permintaan pertemanan",
                    acceptedFriendRequest: "Anda menerima permintaan pertemanan",
                    groupMemberPosted: "Anggota grup memposting sesuatu yang baru",
                    groupMemberRequest: "Anda menerima permintaan bergabung ke grup",
                    acceptedGroupMemberRequest: "Permintaan bergabung ke grup Anda disetujui",
                    rejectedGroupMemberRequest: "Permintaan bergabung ke grup Anda ditolak",
                    newEducationalMedia: "Media pengajaran baru mungkin menarik bagi Anda",
                    default: "Anda memiliki notifikasi baru",
                },
            },
            auth: {
                login: {
                    welcome: "Selamat datang",
                    username: "Nama pengguna:",
                    password: "Kata sandi:",
                    rememberUser: "Ingat saya",
                    forgotPassword: "Lupa kata sandi",
                    submit: "Masuk",
                    guestHint: "Masuk sebagai pengguna atau tamu",
                    googleLogin: "Masuk dengan Google",
                    registerHint: "Tertarik mendaftar sebagai peserta belajar baru?",
                    register: "Daftar",
                    errors: {
                        credentialsRequired: "Silakan masukkan nama pengguna dan kata sandi",
                        success: "Berhasil masuk",
                        tooManyAttempts: "Terlalu banyak percobaan masuk. Silakan coba lagi setelah 5 menit",
                        invalidCredentials: "Nama pengguna atau kata sandi tidak valid",
                    },
                },
                register: {
                    pageTitle: "Daftarkan akun baru",
                    emailSectionTitle: "Informasi email",
                    emailSectionDesc: "Masukkan email Anda untuk menerima nama pengguna dan kata sandi pendaftaran",
                    email: "Email",
                    personalSectionTitle: "Informasi pribadi",
                    personalSectionDesc: "Masukkan detail pribadi untuk ditampilkan di sistem dan aplikasi satuan pendidikan",
                    citizenId: "Nomor identitas nasional",
                    titleLabel: "Gelar",
                    fullName: "Nama lengkap",
                    titleEn: "Gelar (Inggris)",
                    fullNameEn: "Nama lengkap (Inggris)",
                    birthDate: "Tanggal lahir",
                    birthDatePlaceholder: "dd/mm/yyyy",
                    phone: "Nomor telepon kontak",
                    religion: "Agama",
                    submit: "Daftar",
                    cancel: "Batal",
                    successOtp: "Kode OTP telah dikirim ke email Anda",
                    titles: {
                        boy: "Laki-laki",
                        girl: "Perempuan",
                        mr: "Tn.",
                        miss: "Nn.",
                        mrs: "Ny.",
                    },
                    titlesEn: {
                        mr: "Tn.",
                        miss: "Nn.",
                        ms: "Sdri.",
                        mrs: "Ny.",
                    },
                    religions: {
                        buddhist: "Buddha",
                        christian: "Kristen",
                    },
                },
                resetPassword: {
                    title: "Lupa kata sandi",
                    instruction: "Masukkan alamat email yang Anda gunakan dan kami akan mengirim instruksi reset kata sandi",
                    email: "Email",
                    submit: "Kirim email",
                    successMessage: "Kami telah mengirim tautan reset kata sandi ke email Anda. Tautan akan tiba dalam beberapa menit. Jika tidak terlihat, silakan periksa folder spam.",
                    emailRequired: "Silakan masukkan email Anda",
                },
                redeemReset: {
                    title: "Reset kata sandi",
                    username: "Nama pengguna",
                    password: "Kata sandi",
                    confirmPassword: "Konfirmasi kata sandi",
                    passwordHint: "Kata sandi minimal 8 karakter",
                    submit: "Ubah kata sandi",
                    linkExpired: "Tautan ini telah kedaluwarsa atau sudah digunakan untuk mengubah kata sandi",
                    errors: {
                        passwordMinLength: "Kata sandi minimal 8 karakter",
                        passwordMismatch: "Kata sandi tidak cocok",
                        success: "Kata sandi berhasil diubah",
                        failed: "Tidak dapat mengubah kata sandi. Silakan coba lagi",
                    },
                },
                verify: {
                    title: "Verifikasi kode",
                    placeholder: "Masukkan kode verifikasi",
                    submit: "Kirim",
                    success: "Verifikasi berhasil. Detail akun telah dikirim ke email Anda",
                },
            },
            profile: {
                title: "Profil",
                firstName: "Nama depan:",
                lastName: "Nama belakang:",
                email: "Email:",
                school: "Sekolah:",
                schoolArea: "Kantor distrik:",
                province: "Provinsi",
                district: "Distrik",
                position: "Posisi:",
                phone: "Telepon:",
                placeholders: {
                    school: "Kode sekolah - nama",
                    schoolArea: "Kantor distrik",
                    province: "Provinsi",
                    district: "Distrik",
                    phone: "999-999-9999",
                },
                toast: {
                    formSubmitted: "Profil disimpan",
                    uploadSuccess: "Foto berhasil diunggah",
                    updateFailed: "Gagal memperbarui profil",
                },
            },
        },
    },
    ms: {
        translation: {
            common: {
                actions: {
                    logout: "Log keluar",
                    viewAll: "Lihat semua",
                    save: "Simpan",
                    cancel: "Batal",
                    edit: "Edit",
                    delete: "Padam",
                    search: "Cari",
                    choosePhoto: "Pilih foto",
                    upload: "Muat naik",
                },
                roles: {
                    guest: "Pengguna",
                    admin: "Admin pusat",
                    teacher: "Guru",
                    caseManager: "Guru pembimbing",
                    curriculum: "Pakar kurikulum, mata pelajaran, dan penilaian",
                    psychologist: "Pakar pembangunan dan psikologi",
                    student: "Pelajar",
                    adminSystem: "Admin sistem",
                },
                notFound: "Pelayan tidak dapat mencari halaman yang diminta. Sila semak URL yang Anda masukkan.",
                loading: {
                    default: "Memuatkan...",
                },
                status: {
                    active: "Aktif",
                    inactive: "Tidak aktif",
                },
                toast: {
                    success: "Berjaya",
                    error: "Ralat",
                    successDetail: "{{detail}} berjaya",
                    failDetail: "{{detail}} gagal",
                },
            },
            menu: {
                title: "Menu",
            },
            notification: {
                title: "Pemberitahuan ({{count}})",
                markAllRead: "Tandakan semua sebagai telah dibaca",
                unknownGroup: "Kumpulan tidak diketahui",
                unknownUser: "Pengguna tidak diketahui",
                sections: {
                    new: "Baharu",
                    friendRequests: "Permintaan rakan",
                    groupRequests: "Permintaan kumpulan",
                    educationalMedia: "Media pengajaran",
                },
                messages: {
                    commentOnPost: "Seseorang mengomen siaran Anda",
                    likeOnPost: "Seseorang menyukai siaran Anda",
                    replyOnComment: "Seseorang membalas komen Anda",
                    friendRequest: "Anda menerima permintaan rakan",
                    acceptedFriendRequest: "Anda menerima permintaan rakan",
                    groupMemberPosted: "Ahli kumpulan menyiarkan sesuatu yang baharu",
                    groupMemberRequest: "Anda menerima permintaan menyertai kumpulan",
                    acceptedGroupMemberRequest: "Permintaan menyertai kumpulan Anda diluluskan",
                    rejectedGroupMemberRequest: "Permintaan menyertai kumpulan Anda ditolak",
                    newEducationalMedia: "Media pengajaran baharu mungkin menarik untuk Anda",
                    default: "Anda mempunyai pemberitahuan baharu",
                },
            },
            auth: {
                login: {
                    welcome: "Selamat datang",
                    username: "Nama pengguna:",
                    password: "Kata laluan:",
                    rememberUser: "Ingat saya",
                    forgotPassword: "Lupa kata laluan",
                    submit: "Log masuk",
                    guestHint: "Masuk sebagai pengguna atau tetamu",
                    googleLogin: "Log masuk dengan Google",
                    registerHint: "Berminat mendaftar sebagai pelajar baharu?",
                    register: "Daftar",
                    errors: {
                        credentialsRequired: "Sila masukkan nama pengguna dan kata laluan",
                        success: "Berjaya masuk",
                        tooManyAttempts: "Terlalu banyak percubaan masuk. Sila cuba lagi selepas 5 minit",
                        invalidCredentials: "Nama pengguna atau kata laluan tidak sah",
                    },
                },
                register: {
                    pageTitle: "Daftarkan akun baharu",
                    emailSectionTitle: "Maklumat e-mel",
                    emailSectionDesc: "Masukkan e-mel Anda untuk menerima nama pengguna dan kata laluan pendaftaran",
                    email: "E-mel",
                    personalSectionTitle: "Maklumat peribadi",
                    personalSectionDesc: "Masukkan butiran pribadi untuk dipaparkan di sistem dan aplikasi satuan pendidikan",
                    citizenId: "Nombor identiti kebangsaan",
                    titleLabel: "Gelaran",
                    fullName: "Nama penuh",
                    titleEn: "Gelar (Inggeris)",
                    fullNameEn: "Nama lengkap (Inggeris)",
                    birthDate: "Tarikh lahir",
                    birthDatePlaceholder: "dd/mm/yyyy",
                    phone: "Nombor telefon untuk dihubungi",
                    religion: "Agama",
                    submit: "Daftar",
                    cancel: "Batal",
                    successOtp: "Kod OTP telah dikirim ke e-mel Anda",
                    titles: {
                        boy: "Lelaki",
                        girl: "Perempuan",
                        mr: "Encik",
                        miss: "Cik",
                        mrs: "Puan",
                    },
                    titlesEn: {
                        mr: "Encik",
                        miss: "Cik",
                        ms: "Cik",
                        mrs: "Puan",
                    },
                    religions: {
                        buddhist: "Buddha",
                        christian: "Kristian",
                    },
                },
                resetPassword: {
                    title: "Lupa kata laluan",
                    instruction: "Masukkan alamat e-mel yang Anda gunakan dan kami akan mengirim instruksi reset kata laluan",
                    email: "E-mel",
                    submit: "Kirim e-mel",
                    successMessage: "Kami telah mengirim pautan reset kata laluan ke e-mel Anda. Pautan akan tiba dalam beberapa minit. Jika tidak terlihat, sila semak folder spam.",
                    emailRequired: "Sila masukkan e-mel Anda",
                },
                redeemReset: {
                    title: "Reset kata laluan",
                    username: "Nama pengguna",
                    password: "Kata laluan",
                    confirmPassword: "Sahkan kata laluan",
                    passwordHint: "Kata laluan mestilah sekurang-kurangnya 8 aksara",
                    submit: "Tukar kata laluan",
                    linkExpired: "Pautan ini telah tamat tempoh atau sudah digunakan untuk mengubah kata laluan",
                    errors: {
                        passwordMinLength: "Kata laluan mestilah sekurang-kurangnya 8 aksara",
                        passwordMismatch: "Kata laluan tidak sepadan",
                        success: "Kata laluan berjaya ditukar",
                        failed: "Tidak dapat mengubah kata laluan. Sila cuba lagi",
                    },
                },
                verify: {
                    title: "Sahkan kod",
                    placeholder: "Masukkan kod pengesahan",
                    submit: "Hantar",
                    success: "Verifikasi berjaya. Butiran akun telah dikirim ke e-mel Anda",
                },
            },
            profile: {
                title: "Profil",
                firstName: "Nama pertama:",
                lastName: "Nama keluarga:",
                email: "E-mel:",
                school: "Sekolah:",
                schoolArea: "Pejabat daerah:",
                province: "Negeri",
                district: "Daerah",
                position: "Jawatan:",
                phone: "Telefon:",
                placeholders: {
                    school: "Kod sekolah - nama",
                    schoolArea: "Pejabat daerah",
                    province: "Negeri",
                    district: "Daerah",
                    phone: "999-999-9999",
                },
                toast: {
                    formSubmitted: "Profil disimpan",
                    uploadSuccess: "Foto berjaya dimuat naik",
                    updateFailed: "Gagal mengemas kini profil",
                },
            },
        },
    },
    my: {
        translation: {
            common: {
                actions: {
                    logout: "ထွက်ရန်",
                    viewAll: "အားလုံးကြည့်ရန်",
                    save: "သိမ်းရန်",
                    cancel: "မလုပ်တော့ပါ",
                    edit: "ပြင်ရန်",
                    delete: "ဖျက်ရန်",
                    search: "ရှာရန်",
                    choosePhoto: "ဓာတ်ပုံ ရွေးပါ",
                    upload: "အပ်လုဒ်",
                },
                roles: {
                    guest: "အသုံးပြုသူ",
                    admin: "စင်တာအက်ဒမင်",
                    teacher: "ဆရာ/ဆရာမ",
                    caseManager: "အကြံပေးဆရာ/ဆရာမ",
                    curriculum: "သင်ရိုး၊ ဘာသာရပ်နှင့် အကဲဖြတ်မှု ကျွမ်းကျင်သူ",
                    psychologist: "ဖွံ့ဖြိုးမှုနှင့် စိတ်ပညာ ကျွမ်းကျင်သူ",
                    student: "သင်ယူသူ",
                    adminSystem: "စနစ်အက်ဒမင်",
                },
                notFound: "တောင်းဆိုထားသော ဝဘ်ဆိုဒ်ကို ဆာဗာတွင် မတွေ့ပါ။ ထည့်သွင်းထားသော URL ကို စစ်ဆေးပါ။",
                loading: {
                    default: "တင်နေသည်...",
                },
                status: {
                    active: "Active",
                    inactive: "Inactive",
                },
                toast: {
                    success: "Success",
                    error: "Error",
                    successDetail: "{{detail}} အောင်မြင်သည်",
                    failDetail: "{{detail}} မအောင်မြင်ပါ",
                },
            },
            menu: {
                title: "မီနူး",
            },
            notification: {
                title: "အသိပေးချက်များ ({{count}})",
                markAllRead: "အားလုံးကို ဖတ်ပြီးဟု မှတ်ရန်",
                unknownGroup: "အမည်မသိအဖွဲ့",
                unknownUser: "အမည်မသိသူ",
                sections: {
                    new: "အသစ်",
                    friendRequests: "မိတ်ဆွေတောင်းဆိုမှုများ",
                    groupRequests: "အဖွဲ့တောင်းဆိုမှုများ",
                    educationalMedia: "သင်ကြားရေးမီဒီယာ",
                },
                messages: {
                    commentOnPost: "သင့်ပို့စ်တွင် တစ်ယောက်ယောက် မှတ်ချက်ပေးထားသည်",
                    likeOnPost: "သင့်ပို့စ်ကို တစ်ယောက်ယောက် ကြိုက်ထားသည်",
                    replyOnComment: "သင့်မှတ်ချက်ကို တစ်ယောက်ယောက် ပြန်ဖြေထားသည်",
                    friendRequest: "မိတ်ဆွေတောင်းဆိုမှု ရရှိထားသည်",
                    acceptedFriendRequest: "မိတ်ဆွေတောင်းဆိုမှုကို လက်ခံပြီးပါပြီ",
                    groupMemberPosted: "အဖွဲ့ဝင်တစ်ဦးက ပို့စ်အသစ် တင်ထားသည်",
                    groupMemberRequest: "အဖွဲ့ဝင်ရန် တောင်းဆိုမှု ရရှိထားသည်",
                    acceptedGroupMemberRequest: "သင့်အဖွဲ့ဝင်ရန် တောင်းဆိုမှု အတည်ပြုခံရသည်",
                    rejectedGroupMemberRequest: "သင့်အဖွဲ့ဝင်ရန် တောင်းဆိုမှု ငြင်းပယ်ခံရသည်",
                    newEducationalMedia: "သင်စိတ်ဝင်စားနိုင်သော သင်ကြားရေးမီဒီယာအသစ် ရှိသည်",
                    default: "အသိပေးချက်အသစ် ရှိသည်",
                },
            },
            auth: {
                login: {
                    welcome: "ကြိုဆိုပါသည်",
                    username: "အသုံးပြုသူအမည်:",
                    password: "စကားဝှက်:",
                    rememberUser: "အသုံးပြုသူကို မှတ်ထားရန်",
                    forgotPassword: "စကားဝှက် မေ့နေပါသလား",
                    submit: "ဝင်ရောက်ရန်",
                    guestHint: "အသုံးပြုသူ သို့မဟုတ် ဧည့်သည်အဖြစ် ဝင်ရောက်ပါ",
                    googleLogin: "Google ဖြင့် ဝင်ရောက်ရန်",
                    registerHint: "သင်ယူသူအသစ် အဖြစ် မှတ်ပုံတင်လိုပါသလား",
                    register: "မှတ်ပုံတင်ရန်",
                    errors: {
                        credentialsRequired: "အသုံးပြုသူအမည်နှင့် စကားဝှက်ကို ထည့်ပါ",
                        success: "ဝင်ရောက်မှု အောင်မြင်သည်",
                        tooManyAttempts: "ဝင်ရောက်မှု အကြိမ်ရေများလွန်းသည်။ ၅ မိနစ်အကြာ စောင့်ပြီး ထပ်မံကြိုးစားပါ",
                        invalidCredentials: "အသုံးပြုသူအမည် သို့မဟုတ် စကားဝှက် မမှန်ပါ",
                    },
                },
                register: {
                    pageTitle: "အကောင့်အသစ် မှတ်ပုံတင်ရန်",
                    emailSectionTitle: "အီးမေးလ် အချက်အလက်",
                    emailSectionDesc: "မှတ်ပုံတင်ရန် အသုံးပြုသူအမည်နှင့် စကားဝှက် ရရှိရန် အီးမေးလ် ထည့်ပါ",
                    email: "အီးမေးလ်",
                    personalSectionTitle: "ကိုယ်ရေးအချက်အလက်",
                    personalSectionDesc: "စနစ်တွင် ပြသရန်နှင့် ပညာရေးယူနစ် လျှောက်လွှာအတွက် ကိုယ်ရေးအချက်အလက် ထည့်ပါ",
                    citizenId: "နိုင်ငံသားမှတ်ပုံတင်နံပါတ်",
                    titleLabel: "ခေါင်းစဉ်",
                    fullName: "အမည်",
                    titleEn: "ခေါင်းစဉ် (အင်္ဂလိပ်)",
                    fullNameEn: "အမည် (အင်္ဂလိပ်)",
                    birthDate: "မွေးသက္ကရာဇ်",
                    birthDatePlaceholder: "dd/mm/yyyy",
                    phone: "ဆက်သွယ်ရန် ဖုန်းနံပါတ်",
                    religion: "ဘာသာ",
                    submit: "မှတ်ပုံတင်ရန်",
                    cancel: "မလုပ်တော့ပါ",
                    successOtp: "OTP ကုဒ်ကို သင့်အီးမေးလ်သို့ ပို့ပြီးပါပြီ",
                    titles: {
                        boy: "ကောင်လေး",
                        girl: "ကောင်မလေး",
                        mr: "ဦး",
                        miss: "ဒေါ်",
                        mrs: "ဒေါ်",
                    },
                    titlesEn: {
                        mr: "Mr.",
                        miss: "Miss",
                        ms: "Ms.",
                        mrs: "Mrs.",
                    },
                    religions: {
                        buddhist: "ဗုဒ္ဓ",
                        christian: "ခရစ်ယာန်",
                    },
                },
                resetPassword: {
                    title: "စကားဝှက် မေ့နေပါသလား",
                    instruction: "သင်အသုံးပြုသော အီးမေးလ်လိပ်စာကို ထည့်ပါ။ စကားဝှက် ပြန်လည်သတ်မှတ်ရန် ညွှန်ကြားချက်ကို ပို့ပေးပါမည်",
                    email: "အီးမေးလ်",
                    submit: "အီးမေးလ် ပို့ရန်",
                    successMessage: "စကားဝှက် ပြန်လည်သတ်မှတ်ရန် လင့်ခ်ကို အီးမေးလ်သို့ ပို့ပြီးပါပြီ။ မိနစ်အနည်းငယ်အတွင်း ရောက်ရှိသင့်သည်။ မတွေ့ပါက spam ဖိုလ်ဒါကို စစ်ဆေးပါ။",
                    emailRequired: "အီးမေးလ် ထည့်ပါ",
                },
                redeemReset: {
                    title: "စကားဝှက် ပြန်လည်သတ်မှတ်ရန်",
                    username: "အသုံးပြုသူအမည်",
                    password: "စကားဝှက်",
                    confirmPassword: "စကားဝှက် အတည်ပြုရန်",
                    passwordHint: "စကားဝှက် အနည်းဆုံး ၈ လုံး ရှိရမည်",
                    submit: "စကားဝှက် ပြောင်းရန်",
                    linkExpired: "လင့်ခ် သက်တမ်းကုန်ပြီ သို့မဟုတ် စကားဝှက်ပြောင်းရန် အသုံးပြုပြီးပါပြီ",
                    errors: {
                        passwordMinLength: "စကားဝှက် အနည်းဆုံး ၈ လုံး ရှိရမည်",
                        passwordMismatch: "စကားဝှက်များ မတူညီပါ",
                        success: "စကားဝှက် ပြောင်းလဲမှု အောင်မြင်သည်",
                        failed: "စကားဝှက် မပြောင်းနိုင်ပါ။ ထပ်မံကြိုးစားပါ",
                    },
                },
                verify: {
                    title: "ကုဒ် အတည်ပြုရန်",
                    placeholder: "အတည်ပြုကုဒ် ထည့်ပါ",
                    submit: "ပို့ရန်",
                    success: "အတည်ပြုမှု အောင်မြင်သည်။ အကောင့်အချက်အလက်ကို အီးမေးလ်သို့ ပို့ပြီးပါပြီ",
                },
            },
            profile: {
                title: "ပရိုဖိုင်",
                firstName: "အမည် :",
                lastName: "မျိုးရိုးအမည် :",
                email: "အီးမေးလ် :",
                school: "ကျောင်း :",
                schoolArea: "ခရိုင်ရုံး :",
                province: "ပြည်နယ်",
                district: "ခရိုင်/မြို့နယ်",
                position: "ရာထိုင် :",
                phone: "ဖုန်းနံပါတ် :",
                placeholders: {
                    school: "ကျောင်း ကုဒ် - အမည်",
                    schoolArea: "ခရိုင်ရုံး",
                    province: "ပြည်နယ်",
                    district: "ခရိုင်/မြို့နယ်",
                    phone: "999-999-9999",
                },
                toast: {
                    formSubmitted: "ပရိုဖိုင် သိမ်းပြီးပါပြီ",
                    uploadSuccess: "ဓာတ်ပုံ အပ်လုဒ် အောင်မြင်သည်",
                    updateFailed: "ပရိုဖိုင် အပ်ဒိတ် မအောင်မြင်ပါ",
                },
            },
        },
    },
    lo: {
        translation: {
            common: {
                actions: {
                    logout: "ອອກຈາກລະບົບ",
                    viewAll: "ເບິ່ງທັງໝົດ",
                    save: "ບັນທຶກ",
                    cancel: "ຍົກເລີກ",
                    edit: "ແກ້ໄຂ",
                    delete: "ລົບ",
                    search: "ຄົ້ນຫາ",
                    choosePhoto: "ເລືອກຮູບ",
                    upload: "ອັບໂຫຼດ",
                },
                roles: {
                    guest: "ຜູ້ໃຊ້",
                    admin: "ແອດມິນສູນ",
                    teacher: "ຄູ",
                    caseManager: "ຄູທີ່ປຶກສາ",
                    curriculum: "ຜູ້ຊ່ຽວຊານດ້ານຫຼັກສູດ ລາຍວິຊາ ແລະ ການປະເມີນຜົນ",
                    psychologist: "ຜູ້ຊ່ຽວຊານດ້ານພັດທະນາການ ແລະ ຈິດວິທະຍາ",
                    student: "ຜູ້ຮຽນ",
                    adminSystem: "ແອດມິນລະບົບ",
                },
                notFound: "ເຊີບເວີບໍ່ພົບເວັບໄຊທີ່ຮ້ອງຂໍ ກະລຸນາກວດສອບ URL ທີ່ທ່ານພິມເຂົ້າລະບົບ",
                loading: {
                    default: "ກຳລັງໂຫຼດ...",
                },
                status: {
                    active: "Active",
                    inactive: "Inactive",
                },
                toast: {
                    success: "Success",
                    error: "Error",
                    successDetail: "{{detail}} ສຳເລັດ",
                    failDetail: "{{detail}} ບໍ່ສຳເລັດ",
                },
            },
            menu: {
                title: "ເມນູ",
            },
            notification: {
                title: "ການແຈ້ງເຕືອນ ({{count}})",
                markAllRead: "ໝາຍທັງໝົດວ່າອ່ານແລ້ວ",
                unknownGroup: "ກຸ່ມບໍ່ຮູ້ຊື່",
                unknownUser: "ບໍ່ຮູ້ຊື່",
                sections: {
                    new: "ໃໝ່",
                    friendRequests: "ຄຳຂໍເປັນໝູ່",
                    groupRequests: "ຄຳຂໍຂອງກຸ່ມ",
                    educationalMedia: "ສື່ການສອນ",
                },
                messages: {
                    commentOnPost: "ມີຄົນແສດງຄວາມເຫັນໃນໂພສຂອງທ່ານ",
                    likeOnPost: "ມີຄົນຖືກໃຈໂພສຂອງທ່ານ",
                    replyOnComment: "ມີຄົນຕອບກັບຄວາມເຫັນຂອງທ່ານ",
                    friendRequest: "ທ່ານໄດ້ຮັບຄຳຂໍເປັນໝູ່",
                    acceptedFriendRequest: "ທ່ານໄດ້ຕອບຮັບຄຳຂໍເປັນໝູ່ແລ້ວ",
                    groupMemberPosted: "ມີສະມາຊິກໃນກຸ່ມໂພສໃໝ່",
                    groupMemberRequest: "ທ່ານໄດ້ຮັບຄຳຂໍເຂົ້າຮ່ວມກຸ່ມ",
                    acceptedGroupMemberRequest: "ຄຳຂໍເຂົ້າຮ່ວມກຸ່ມຂອງທ່ານໄດ້ຮັບການອະນຸມັດ",
                    rejectedGroupMemberRequest: "ຄຳຂໍເຂົ້າຮ່ວມກຸ່ມຂອງທ່ານຖືກປະຕິເສດ",
                    newEducationalMedia: "ມີສື່ການສອນໃໝ່ທີ່ທ່ານອາດສົນໃຈ",
                    default: "ທ່ານມີການແຈ້ງເຕືອນໃໝ່",
                },
            },
            auth: {
                login: {
                    welcome: "ຍິນດີຕ້ອນຮັບ",
                    username: "ຊື່ຜູ້ໃຊ້:",
                    password: "ລະຫັດຜ່ານ:",
                    rememberUser: "ຈື່ຜູ້ໃຊ້",
                    forgotPassword: "ລືມລະຫັດຜ່ານ",
                    submit: "ເຂົ້າສູ່ລະບົບ",
                    guestHint: "ເຂົ້າສູ່ລະບົບໃນຖານະຜູ້ໃຊ້ ຫຼື ຜູ້ເຂົ້າຊົມ",
                    googleLogin: "Login with Google",
                    registerHint: "ສົນໃຈລົງທະບຽນສຳລັບຜູ້ຮຽນໃໝ່",
                    register: "ລົງທະບຽນ",
                    errors: {
                        credentialsRequired: "ກະລຸນາລະບຸຊື່ຜູ້ໃຊ້ ແລະ ລະຫັດຜ່ານ",
                        success: "ເຂົ້າສູ່ລະບົບສຳເລັດ",
                        tooManyAttempts: "ພະຍາຍາມເຂົ້າລະບົບຫຼາຍເທື່ອ ກະລຸນາລອງໃໝ່ຫຼັງ 5 ນາທີ",
                        invalidCredentials: "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ",
                    },
                },
                register: {
                    pageTitle: "ລົງທະບຽນບັນຊີຜູ້ໃຊ້ໃໝ່",
                    emailSectionTitle: "ຂໍ້ມູນອີເມວ",
                    emailSectionDesc: "ກະລຸນາກອກອີເມວເພື່ອຮັບຊື່ຜູ້ໃຊ້ ແລະ ລະຫັດຜ່ານສຳລັບການລົງທະບຽນ",
                    email: "ອີເມວ",
                    personalSectionTitle: "ຂໍ້ມູນສ່ວນຕົວ",
                    personalSectionDesc: "ກອກຂໍ້ມູນສ່ວນຕົວເພື່ອສະແດງໃນລະບົບ ແລະ ໃຊ້ໃນການສະໝັກເຂົ້າຫນ່ວຍການສຶກສາ",
                    citizenId: "ເລກບັດປະຊາຊົນ",
                    titleLabel: "ຄຳນຳໜ້າ",
                    fullName: "ຊື່-ນາມສະກຸນ",
                    titleEn: "ຄຳນຳໜ້າ (ພາສາອັງກິດ)",
                    fullNameEn: "ຊື່-ນາມສະກຸນ (ພາສາອັງກິດ)",
                    birthDate: "ວັນ/ເດືອນ/ປີເກີດ",
                    birthDatePlaceholder: "dd/mm/yyyy",
                    phone: "ເບີໂທຕິດຕໍ່ໄດ້",
                    religion: "ສາສະໜາ",
                    submit: "ລົງທະບຽນ",
                    cancel: "ຍົກເລີກ",
                    successOtp: "ສົ່ງລະຫັດ OTP ໄປທີ່ອີເມວຂອງທ່ານແລ້ວ",
                    titles: {
                        boy: "ເດັກຊາຍ",
                        girl: "ເດັກຍິງ",
                        mr: "ທ້າວ",
                        miss: "ນາງ",
                        mrs: "ນາງ",
                    },
                    titlesEn: {
                        mr: "Mr.",
                        miss: "Miss",
                        ms: "Ms.",
                        mrs: "Mrs.",
                    },
                    religions: {
                        buddhist: "ພຸດ",
                        christian: "ຄຣິດ",
                    },
                },
                resetPassword: {
                    title: "ລືມລະຫັດຜ່ານ",
                    instruction: "ລະບຸທີ່ຢູ່ອີເມວທີ່ທ່ານໃຊ້ ແລະ ພວກເຮົາຈະສົ່ງຄຳແນະນຳການຣີເຊັດລະຫັດຜ່ານ",
                    email: "ອີເມວ",
                    submit: "ສົ່ງອີເມວ",
                    successMessage: "ພວກເຮົາໄດ້ສົ່ງລິ້ງຣີເຊັດລະຫັດຜ່ານໄປຫາທ່ານແລ້ວ ຄວນປາກົດໃນອີເມວພາຍໃນໄม่ກີ້ນາທີ ຖ້າຍັງບໍ່ເຫັນ ກະລຸນາກວດໂຟລເດີ spam",
                    emailRequired: "ກະລຸນາລະບຸອີເມວ",
                },
                redeemReset: {
                    title: "ຣີເຊັດລະຫັດຜ່ານ",
                    username: "ຊື່ຜູ້ໃຊ້",
                    password: "ລະຫັດຜ່ານ",
                    confirmPassword: "ຢືນຢັນລະຫັດຜ່ານ",
                    passwordHint: "ລະຫັດຜ່ານຕ້ອງຍາວຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
                    submit: "ປ່ຽນລະຫັດຜ່ານ",
                    linkExpired: "ລິ້ງໝົດອາຍຸ ຫຼື ຖືກໃຊ້ປ່ຽນລະຫັດຜ່ານແລ້ວ",
                    errors: {
                        passwordMinLength: "ລະຫັດຜ່ານຕ້ອງຍາວຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
                        passwordMismatch: "ລະຫັດຜ່ານບໍ່ກົງກັນ",
                        success: "ປ່ຽນລະຫັດຜ່ານສຳເລັດ",
                        failed: "ບໍ່ສາມາດປ່ຽນລະຫັດຜ່ານໄດ້ ກະລຸນາລອງໃໝ່",
                    },
                },
                verify: {
                    title: "ຢືນຢັນລະຫັດ",
                    placeholder: "ກອກລະຫັດຢືນຢັນ",
                    submit: "ສົ່ງ",
                    success: "ຢືນຢັນສຳເລັດ ສົ່ງບັນຊີໄປທີ່ອີເມວຂອງທ່ານແລ້ວ",
                },
            },
            profile: {
                title: "ໂປຣໄຟລ໌",
                firstName: "ຊື່ :",
                lastName: "ນາມສະກຸນ :",
                email: "ອີເມວ :",
                school: "ໂຮງຮຽນ :",
                schoolArea: "ສຳນັກງານເຂດ :",
                province: "ແຂວງ",
                district: "ເຂດ/ອຳເພີ",
                position: "ຕຳແໜ່ງ :",
                phone: "ເບີໂທລະສັບ :",
                placeholders: {
                    school: "ລະຫັດ-ຊື່ໂຮງຮຽນ",
                    schoolArea: "ສຳນັກງານເຂດ",
                    province: "ແຂວງ",
                    district: "ເຂດ/ອຳເພີ",
                    phone: "999-999-9999",
                },
                toast: {
                    formSubmitted: "ບັນທຶກໂປຣໄຟລ໌ແລ້ວ",
                    uploadSuccess: "ອັບໂຫຼດຮູບສຳເລັດ",
                    updateFailed: "ອັບເດດໂປຣໄຟລ໌ບໍ່ສຳເລັດ",
                },
            },
        },
    },
};

const resources = mergeI18nResources(
    sharedResources,
    commonResources,
    ssoResources,
    authPageResources
);

export default resources;
